import React from 'react';
import { Car, Heart } from 'lucide-react';

export function EmptyState({ t, showFavourites }) {
  return (
    <div className="text-center py-12">
      {showFavourites ? (
        <>
          <Heart className="w-12 h-12 mx-auto mb-3 text-slate-600" />
          <p className="text-slate-400">{t('noFavourites')}</p>
          <p className="text-sm text-slate-500 mt-1">{t('noFavouritesHint')}</p>
        </>
      ) : (
        <>
          <Car className="w-12 h-12 mx-auto mb-3 text-slate-600" />
          <p className="text-slate-400">{t('noOpportunities')}</p>
          <p className="text-sm text-slate-500 mt-1">{t('noOpportunitiesHint')}</p>
        </>
      )}
    </div>
  );
}

export default EmptyState;
